var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header-comp'),_c('hero-comp'),_c('projects-comp'),_c('contact-comp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }